import { useEffect, useRef } from "react";
import { useFormikContext } from "formik";

const ScrollToFieldError = () => {
  const { submitCount, isValidating, errors, isSubmitting } = useFormikContext();
  const lastSubmitCountRef = useRef(0);

  useEffect(() => {
    if (submitCount < lastSubmitCountRef.current) {
      lastSubmitCountRef.current = submitCount;
    }

    if (submitCount > lastSubmitCountRef.current && !isValidating && !isSubmitting) {
      if (Object.keys(errors).length > 0) {
        // Find the first error key (recursively if nested)
        const getFirstErrorKey = (obj, prefix = "") => {
          const keys = Object.keys(obj);
          if (keys.length === 0) return null;
          const firstKey = keys[0];
          const newPrefix = prefix ? `${prefix}.${firstKey}` : firstKey;
          
          if (typeof obj[firstKey] === "object" && obj[firstKey] !== null && !Array.isArray(obj[firstKey])) {
            return getFirstErrorKey(obj[firstKey], newPrefix);
          }
          return newPrefix;
        };

        const firstErrorKey = getFirstErrorKey(errors);

        if (firstErrorKey) {
          // We will try finding the element by name or id
        
          const errorElement = document.querySelector(
            `[name="${firstErrorKey}"], [id="${firstErrorKey}"]`
          );

          if (errorElement) {
            errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            
            // Optional: focus the element if it's focusable
            if (typeof errorElement.focus === "function") {
              errorElement.focus({ preventScroll: true });
            }
          }
        }
      }
      lastSubmitCountRef.current = submitCount;
    }
  }, [submitCount, isValidating, errors, isSubmitting]);

  return null; // This component doesn't render anything
};

export default ScrollToFieldError;
